import React from 'react';
import PropTypes from 'prop-types';

const CategoryCheckbox = ({ category, index, onCheckedMass }) => (
  <div className="services-import__list-category-checkbox">
    <input
      type="checkbox"
      id={`select_all_${index}`}
      checked={category.checked}
      disabled={category.disabled}
      onChange={() => onCheckedMass(category.services, category.checked)}
    />
  </div>
);

CategoryCheckbox.propTypes = {
  category: PropTypes.object,
  index: PropTypes.number,
  onCheckedMass: PropTypes.func,
};
export default CategoryCheckbox;
